var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipUpgradeGiFs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 447 60.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(296 2.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 150,
    height: 58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(296 2.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.55,
    width: 150,
    height: 56.95
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(296 2.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,45.22a2,2,0,0,1-2-2V4.55a2,2,0,0,1,2-2H144a2,2,0,0,1,2,2V43.22a2,2,0,0,1-2,2H81l-4.46,5.54a2,2,0,0,1-2.82.3,2.13,2.13,0,0,1-.3-.3L69,45.22Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 296,
    y: 2.45,
    width: 150,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAA6CAYAAABS36B3AAAACXBIWXMAAAsSAAALEgHS3X78AAAC0ElEQVR4Xu2dy27rMAwFj9K09/8/t00a3oXFmGLkoCjARaMZQPBzY2L08oJsZqYjWmvt8CEsjz2Rp5lZFqilI8AzLB1lZnZOLzVJp3D0ewAZF+nWz2/hnpp2cU69vfXm1/4egBOlukn67s2v5SOWj1Bvkt57c8GQCmaYdqEu6b5lsc6SPiT96+c+cgFkfKS6avPHFKbEmVjv2uT6EGLBMS7Wl8bpsEmbSC20KJdPh4gFM27a3DBto5Zv+pqkFneFLtZsEQ+QyZu+U7g3lSbuFFm4wxHRkQdPslizH6UARxz6wjQHJSAWlIBYUAJiQQmIBSUgFpSAWFACYkEJiAUlIBaUgFhQAmJBCYgFJSAWlIBYUAJiQQmIBSUgFpSAWFACYkEJiAUlIBaUgFhQAmJBCYgFJSAWlIBYUAJiQQmIBSUgFpSAWFBCFitWGjguWQGwcehLLiDgL8S2Gr9NOLdarJ564mLFVMrfGjPg/jbQf42cHvMn3x6D+lD648WJed69eMA9HmftgYh5uy/h3k8C/CrE7NGncD4jlvoYgroA/q3uylW7XFLI8+4B8hdbf3GlrMk5JblnjZYeY5BLfVy1nlx5IIoxUBYrJoTP9XReHZfqTWOue4+Rx8Gl8oDmHruSWFGu4ftnI5bPnT4VrDANxpzlLpUP6/n7PZgXSZ/aOmLssdIacsV1ucdkF8vMrNcrtPCgaZRqBbmkTSzvfTEO0rgWvWgT6rO3i8Y1xqsTNyq57fUKk1we0MgqYjWN01mUykf3q0apvjTKuAL5O+/XXnX1nG9I0qRi7yoBi53Lr9Wvr/3c16FxGnSpVonTwKyE7+wH6dNav69M6FC+3oxLBN8hulh5J2Srxm3GVKxV6UsCaVwrmfZfL9L4i+G+YEWqEcSa46OUn9/r8IVn3hBqQqOjPdL2OTHvjp2HXZBgALEOaI87mPzbYbsggFMQC0r4D+nULXQUunxIAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-294,45.22a2,2,0,0,1-2-2V4.55a2,2,0,0,1,2-2h138a2,2,0,0,1,2,2V43.22a2,2,0,0,1-2,2h-63l-4.46,5.54a2,2,0,0,1-2.82.3,2.13,2.13,0,0,1-.3-.3L-231,45.22Z",
    transform: "translate(296 2.45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 295,
    width: 152,
    height: 58.95
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(318.26 21.21)"
  }, "Upgrade your account "), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(321.99 34.21)"
  }, "to start sending GIFs")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipUpgradeGiFs);
export default __webpack_public_path__ + "static/media/TopicTip_UpgradeGIFs.b756b0d0c673d345b6acc3b72c8f9827.svg";
export { ForwardRef as ReactComponent };